import * as constants from '../../app/shared/constants'

declare function DDfireTag(id, dv) : any;

export class OmnitureTags {

    globalBlock = {
        'breakpoint': window.screen.availWidth,
        'device_type': constants.MOBILE ? 'mobile' : 'desktop',
        'zipcode': '',
        'error_type': '',
        'tda_code': '',
        'tool_name': 'rtid'
    };

    userBlock = {
        'user_digital_garage_id': '',
        'user_zipcode': '',
        'user_logged_status': '',
        'user_city': ''
    };

    userInputErrorBlock = {
        'displayed_error_message': ''
    };

    sectionBlock = {
        'content_section': '',
    };

    dealerBlock = {
        'dealer_brand': 'Toyota',
        'dealer_code': '',
        'dealer_name': '',
        'dealer_zipcode': '',
        'dealer_city': '',
        'dealer_state': ''
    };

    linkBlock = {
        'link_url': '',
        'link_href': '',
        'link_text': '',
        'link_trigger': '',
        'link_action': ''
    };

    listItemBlock = {
        'list_item_index': ''
    };

    offerBlock = {
        'offer_category': '',
        'offer_type': '',
        'offer_id': '',
        'offer_expired_date': '',
        'offer_term': '',
        'offer_rate': '',
        'offer_amtdue': '',
        'offer_monthly': '',
        'offer_cashback': '',
        'offer_title': '',
        'offer_label': ''
    };

    partsBlock = {
        'parts_id': '',
        'parts_name': ''
    };

    offerVehicleBlock = {
        'offer_series_number': '',
        'offer_series_mrp': '',
        'offer_series_brand': '',
        'offer_series_grade': '',
        'offer_series_engine': '',
        'offer_series_transmission': '',
        'offer_series_category': '',
        'offer_series_accessories_name': '',
        'offer_series_color_ext': '',
        'offer_series_color_int': '',
        'offer_series_color_ext_code': '',
        'offer_series_color_int_code': '',
        'offer_series_code': '',
        'offer_series_year': '',
        'offer_series_fuel_type': '',
        'offer_series_packages': '',
        'offer_series_body_style': '',
        'offer_series_inventory_type': '',
        'offer_series_vehicleid': ''
    };

    vehicleBlock = {
        'series_number': '',
        'series_msrp': '',
        'series_brand': '',
        'series_grade': '',
        'series_engine': '',
        'series_transmission': '',
        'series_category': '',
        'series_accessories_name': '',
        'series_color_ext': '',
        'series_color_int': '',
        'series_inventory_availability': '',
        'series_color_ext_code': '',
        'series_color_int_code': '',
        'series_code': '',
        'series_year': '',
        'series_fuel_type': '',
        'series_packages': '',
        'series_body_style': '',
        'series_inventory_type': '',
        'series_vehicleid': '',
        'series_vin': ''
    };

    omnitureBlocks = [
        {
            name: 'vh_aa-pageload',
            value: {
                tagName: 'aa-pageload',
                contentSection : 'vehicles_home',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : null,
                    listItemBlock : null,
                    vehicleBlock : null,
                    partsBlock : null,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'vh_km-dealer-contact-call',
            value: {
                tagName: 'km-dealer-contact-call',
                contentSection: 'dealer_info_module',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : this.linkBlock,
                    listItemBlock : null,
                    vehicleBlock : null,
                    partsBlock : null,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'vh_aa-link_vehicle_module',
            value: {
                tagName: 'aa-link',
                contentSection: 'vehicle_module',
                blocks: 
                {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : this.linkBlock,
                    listItemBlock : this.listItemBlock,
                    vehicleBlock : this.vehicleBlock,
                    partsBlock : null,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'vh_aa-link_dealer_info_module',
            value: {
                tagName: 'aa-link',
                contentSection: 'dealer_info_module',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : this.linkBlock,
                    listItemBlock : null,
                    vehicleBlock : null,
                    partsBlock : null,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'vh_aa-link_app_menu_module',
            value: {
                tagName: 'aa-link',
                contentSection: 'app_menu_module',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : this.linkBlock,
                    listItemBlock :null,
                    vehicleBlock : null,
                    partsBlock : null,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'vh_aa-link_header_module',
            value: {
                tagName: 'aa-link',
                contentSection: 'header_module',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : this.linkBlock,
                    listItemBlock : null,
                    vehicleBlock : null,
                    partsBlock : null,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'vd_km-inventory-detail',
            value: {
                tagName: 'km-inventory-detail',
                contentSection: 'vehicle_detail',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : null,
                    listItemBlock : null,
                    vehicleBlock : this.vehicleBlock,
                    partsBlock : null,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'vd_km-rab-download',
            value: {
                tagName: 'km-rab-download',
                contentSection: 'vehicle_header_module',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : this.linkBlock,
                    listItemBlock : null,
                    vehicleBlock : this.vehicleBlock,
                    partsBlock : null,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'vheader_km-dealer-contact-call',
            value: {
                tagName: 'km-dealer-contact-call',
                contentSection: 'app_header_module',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : this.linkBlock,
                    listItemBlock : null,
                    vehicleBlock : this.vehicleBlock,
                    partsBlock : null,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'vd_km-dealer-contact-call',
            value: {
                tagName: 'km-dealer-contact-call',
                contentSection: 'download_module',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : this.linkBlock,
                    listItemBlock : null,
                    vehicleBlock : this.vehicleBlock,
                    partsBlock : null,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'vd_aa-link_vehicle_header_module',
            value: {
                tagName: 'aa-link',
                contentSection: 'vehicle_header_module',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : this.linkBlock,
                    listItemBlock : this.listItemBlock,
                    vehicleBlock : this.vehicleBlock,
                    partsBlock : null,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'vd_aa-link_app_menu_module',
            value: {
                tagName: 'aa-link',
                contentSection: 'app_menu_module',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : this.linkBlock,
                    listItemBlock : null,
                    vehicleBlock : this.vehicleBlock,
                    partsBlock : null,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'vd_aa-subpageload_packages_accessories_module',
            value: {
                tagName: 'aa-subpageload',
                contentSection: 'packages_accessories_module',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : null,
                    listItemBlock : null,
                    vehicleBlock : this.vehicleBlock,
                    partsBlock : null,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'vd_aa-subpageload_features_module',
            value: {
                tagName: 'aa-subpageload',
                contentSection: 'Features_module',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : null,
                    listItemBlock : null,
                    vehicleBlock : this.vehicleBlock,
                    partsBlock : null,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'vd_km-other-download',
            value: {
                tagName: 'km-other-download',
                contentSection: 'download_module',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : this.linkBlock,
                    listItemBlock : null,
                    vehicleBlock : this.vehicleBlock,
                    partsBlock : null,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'vd_aa-link_download',
            value: {
                tagName: 'aa-link',
                contentSection: 'download_module',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : this.linkBlock,
                    listItemBlock : null,
                    vehicleBlock : this.vehicleBlock,
                    partsBlock : null,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'va_aa-pageload',
            value: {
                tagName: 'aa-pageload',
                contentSection: 'Vehicle_accessories',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : null,
                    listItemBlock : null,
                    vehicleBlock : this.vehicleBlock,
                    partsBlock : null,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'va_aa-link',
            value: {
                tagName: 'aa-link',
                contentSection: 'Accessories_carousel',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : this.linkBlock,
                    listItemBlock : this.listItemBlock,
                    vehicleBlock : this.vehicleBlock,
                    partsBlock : this.partsBlock,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'va_aa-subpageload',
            value: {
                tagName: 'aa-subpageload',
                contentSection: 'vehicle_accessories_modal',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : null,
                    listItemBlock : null,
                    vehicleBlock : this.vehicleBlock,
                    partsBlock : this.partsBlock,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'vp_aa-pageload',
            value: {
                tagName: 'aa-pageload',
                contentSection: 'Vehicle_protectionproducts',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : null,
                    listItemBlock : null,
                    vehicleBlock : this.vehicleBlock,
                    partsBlock : null,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'vp_aa-link',
            value: {
                tagName: 'aa-link',
                contentSection: 'ProtectionProducts_card',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : this.linkBlock,
                    listItemBlock : this.listItemBlock,
                    vehicleBlock : this.vehicleBlock,
                    partsBlock : this.partsBlock,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'vp_aa-subpageload',
            value: {
                tagName: 'aa-subpageload',
                contentSection: 'Vehicle_protectionproducts_details',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : null,
                    listItemBlock : null,
                    vehicleBlock : this.vehicleBlock,
                    partsBlock : this.partsBlock,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
        {
            name: 'vpp_aa-subpageload',
            value: {
                tagName: 'aa-subpageload',
                contentSection: 'Vehicle_protectionproducts_plan_details',
                blocks: {
                    globalBlock : this.globalBlock,
                    userBlock : this.userBlock,
                    userInputErrorBlock : this.userInputErrorBlock,
                    sectionBlock : this.sectionBlock,
                    dealerBlock : this.dealerBlock,
                    linkBlock : null,
                    listItemBlock : null,
                    vehicleBlock : this.vehicleBlock,
                    partsBlock : this.partsBlock,
                    offerBlock : null,
                    offerVehicleBlock : null
                }
            }
        },
    ];

    public fireOmnitureTag(eventName : string, data : any, sharedData: any) {
        let tagData = this.omnitureBlocks.find( x => x.name == eventName);
        let id : string;
        let dv: any = {};
        
        if(tagData != null) {
          id = tagData.value.tagName;
          if(tagData.value.blocks.globalBlock != null)
            dv = Object.assign(dv, tagData.value.blocks.globalBlock);
    
          if(tagData.value.blocks.userBlock != null)
          dv = Object.assign(dv, tagData.value.blocks.userBlock);
          
          if(tagData.value.blocks.userInputErrorBlock != null)
          dv = Object.assign(dv, tagData.value.blocks.userInputErrorBlock);
          
          if(tagData.value.blocks.sectionBlock != null) {
            tagData.value.blocks.sectionBlock.content_section = tagData.value.contentSection;
            dv = Object.assign(dv, tagData.value.blocks.sectionBlock);
          }
          
          if(tagData.value.blocks.dealerBlock != null) {
            tagData.value.blocks.dealerBlock.dealer_brand = 'Toyota';
            tagData.value.blocks.dealerBlock.dealer_name = sharedData.dealerDetails != null ? sharedData.dealerDetails.dealerName : null;
            tagData.value.blocks.dealerBlock.dealer_code = sharedData.vehicleDetails != null ? sharedData.vehicleDetails.dealerCd : (data != null && data.dealerCd != null ? data.dealerCd : sharedData.dealerDetails.dealerCode) ;
            tagData.value.blocks.dealerBlock.dealer_zipcode = sharedData.dealerDetails != null ? sharedData.dealerDetails.zip : null;
            tagData.value.blocks.dealerBlock.dealer_city = sharedData.dealerDetails != null ? sharedData.dealerDetails.city : null;
            tagData.value.blocks.dealerBlock.dealer_state = sharedData.dealerDetails != null ? sharedData.dealerDetails.state : null; 
            dv = Object.assign(dv, tagData.value.blocks.dealerBlock);
          }
    
          if(tagData.value.blocks.linkBlock != null) {
            tagData.value.blocks.linkBlock.link_url = data.url;
            tagData.value.blocks.linkBlock.link_href = data.href;
            tagData.value.blocks.linkBlock.link_text = data.text;
            tagData.value.blocks.linkBlock.link_trigger = data.trigger;
            dv = Object.assign(dv, tagData.value.blocks.linkBlock);
          }
    
          if(tagData.value.blocks.listItemBlock != null) {
            tagData.value.blocks.listItemBlock.list_item_index = data.listIndex;  
            dv = Object.assign(dv, tagData.value.blocks.listItemBlock)
          }
    
          if(tagData.value.blocks.vehicleBlock != null && data != null && data.vehicleDetails != null) {
            tagData.value.blocks.vehicleBlock.series_msrp = data.vehicleDetails.price.totalMsrp;
            tagData.value.blocks.vehicleBlock.series_year = data.vehicleDetails.year;
            tagData.value.blocks.vehicleBlock.series_vin = data.vehicleDetails.vin;
            tagData.value.blocks.vehicleBlock.series_code = data.vehicleDetails.marketingSeries;
            dv = Object.assign(dv, tagData.value.blocks.vehicleBlock);
          }
          else if(tagData.value.blocks.vehicleBlock != null && sharedData.vehicleDetails != null) {
            tagData.value.blocks.vehicleBlock.series_code = sharedData.vehicleDetails.seriesCode;
            tagData.value.blocks.vehicleBlock.series_msrp = sharedData.vehicleDetails.price.baseMsrp;
            tagData.value.blocks.vehicleBlock.series_color_ext = sharedData.vehicleDetails.extColor.marketingName;
            tagData.value.blocks.vehicleBlock.series_color_int = sharedData.vehicleDetails.intColor.marketingName;
            tagData.value.blocks.vehicleBlock.series_year = sharedData.vehicleDetails.year;
            tagData.value.blocks.vehicleBlock.series_vin = sharedData.vehicleDetails.vin;
            tagData.value.blocks.vehicleBlock.series_color_ext_code = sharedData.vehicleDetails.extColor.colorCd;
            tagData.value.blocks.vehicleBlock.series_color_int_code = sharedData.vehicleDetails.intColor.colorCd;
            tagData.value.blocks.vehicleBlock.series_engine = sharedData.vehicleDetails.engine.name;
            tagData.value.blocks.vehicleBlock.series_fuel_type = sharedData.vehicleDetails.engine.fuelType;
            tagData.value.blocks.vehicleBlock.series_packages = sharedData.vehicleDetails.options.map(x => x.marketingName);
            tagData.value.blocks.vehicleBlock.series_brand = sharedData.vehicleDetails.brand;
            tagData.value.blocks.vehicleBlock.series_transmission = sharedData.vehicleDetails.transmission.transmissionType;
            tagData.value.blocks.vehicleBlock.series_number = sharedData.vehicleDetails.stockNum;
            tagData.value.blocks.vehicleBlock.series_grade = sharedData.vehicleDetails.bodyStyleDesc;
            dv = Object.assign(dv, tagData.value.blocks.vehicleBlock);
          } 
    
          
          if(tagData.value.blocks.partsBlock != null) {
            tagData.value.blocks.partsBlock.parts_id = data.part.partNbr;
            tagData.value.blocks.partsBlock.parts_name = data.part.marketingName;
            dv = Object.assign(dv, tagData.value.blocks.partsBlock)
          }
    
          if(tagData.value.blocks.offerBlock != null) {
            dv = Object.assign(dv, tagData.value.blocks.offerBlock)
          }
    
          if(tagData.value.blocks.offerVehicleBlock != null) {
            dv = Object.assign(dv, tagData.value.blocks.offerVehicleBlock)
          }
    
          DDfireTag(id, dv); 
        }
    
      }
}